let clientId;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'favacbid.airwis.com') {
  clientId = '07f9222f-8fd2-47a4-9cab-71d9774e23ba';
} else if (hostname === 'favacbidtest.airwis.com') {
  clientId = '697921a0-15e9-42a7-b9cd-48123a239734';
} else {
  clientId = '697921a0-15e9-42a7-b9cd-48123a239734'
}

export const CLIENT_ID = `${clientId}`;